import { render, staticRenderFns } from "./OrderCreatedShare.vue?vue&type=template&id=7189eb4f&"
import script from "./OrderCreatedShare.vue?vue&type=script&lang=js&"
export * from "./OrderCreatedShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OrderCreatedShare.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7189eb4f')) {
      api.createRecord('7189eb4f', component.options)
    } else {
      api.reload('7189eb4f', component.options)
    }
    module.hot.accept("./OrderCreatedShare.vue?vue&type=template&id=7189eb4f&", function () {
      api.rerender('7189eb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/OrderCreatedShare.vue"
export default component.exports